import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, Icon } from "semantic-ui-react";

import { CUSTOM_CONFIRM_TYPES, Can, CustomConfirm } from "components";
import { usePermanentRealTimeUser } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES, ROLES } from "models";
import { useDeleteLocationMutation } from "modules/DealerLocationDetails/components/LocationDetailActions/hooks";
import { PATHS } from "router/paths";

import type { DealerLocation } from "models";

type LocationDetailActionsProps = {
  location: DealerLocation;
};

export const LocationDetailActions = ({ location }: LocationDetailActionsProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);

  const { user } = usePermanentRealTimeUser();
  const { mutate: deleteLocation, isPending: isDeleteLocationPending, error: deleteLocationError } = useDeleteLocationMutation();

  if (user?.role_id !== ROLES.SuperAdmin) return null;

  return (
    <Can I={ACL_ACTIVITIES.Delete} the={ACL_RESOURCES.Locations}>
      <div className="dealer-location-actions">
        <Button type="button" color="red" onClick={() => setIsDeleteConfirmOpen(true)}>
          {t("v8_delete", "Delete")}
          <Icon className="trash" />
        </Button>
      </div>
      <CustomConfirm
        type={CUSTOM_CONFIRM_TYPES.Danger}
        isOpen={isDeleteConfirmOpen}
        isLoading={isDeleteLocationPending}
        error={deleteLocationError?.message}
        confirmMsg={t("v8_confirm_delete_location", "Are you sure that you want to delete {{locationName}}? You can't undo this action.", {
          locationName: location.name
        })}
        handleCancel={() => setIsDeleteConfirmOpen(false)}
        handleConfirm={() => deleteLocation(location, { onSuccess: () => history.push(PATHS.DEALERS_DASHBOARD) })}
      />
    </Can>
  );
};
